import { info_tab, preview_tab } from '../../../../../../views/contract/template';

export default {
  title: 'Kontraktskabelon',
  tabs: {
    [info_tab]: 'Info',
    [preview_tab]: 'Vis',
  },
  sections: {
    subscription: 'Abonnement',
    setup_cost: 'Oprettelsesgebyr',
    preview: 'Vis',
  },
  form: {
    has_trial: {
      label: 'Tilføj prøvedage',
    },
    trial_days: {
      label: 'Gratis prøvedage',
      placeholder: '7',
      validation: {
        required: 'Prøvedage er påkrævet',
        min: '{{value}} er minimumsværdien for prøvedage',
      },
    },
  },
  buttons: {
    apply: 'Anvend ændringer',
    download: 'Download',
    apply_changes: 'Anvend ændringer',
  },
  files: {
    contract: '{{provider}}-kontraktskabelon-{{company}}.pdf',
  },
  toasts: {
    failed_to_load_data: 'Forhåndsvisningen kunne ikke indlæses',
  },
};
